import { JsonObject } from '../types/JsonObject';

type ProblemDetails = {
    title?: string;
    status?: number;
    type?: string;
    validation?: Record<string, { type: string; message: string }[]>;
};

type FetchJsonOk = {
    ok: true;
    status: number;
    statusText: string;
    data: JsonObject;
};

type FetchHttpProblem = {
    ok: false;
    error: 'http';
    status: number;
    statusText: string;
    problem: ProblemDetails;
};

type FetchError = {
    ok: false;
    error: 'request';
    name: string;
    message: string;
};

export type FetchJsonResult = FetchJsonOk | FetchHttpProblem | FetchError;

export const postJson = async ({
    uri,
    data,
}: {
    uri?: string;
    data?: object | string;
}): Promise<FetchJsonResult> => {
    const body = data ? JSON.stringify(data) : null;
    const headers = {
        'Content-Type': 'application/json',
    };

    try {
        const response = await fetch(`${uri}`, {
            method: 'POST',
            headers,
            body,
            cache: 'no-store',
        });

        if (response.ok) {
            return await httpOk(response);
        } else {
            return await httpError(response);
        }
    } catch (error) {
        return fetchError(error);
    }
};

export const getJson = async ({
    uri,
    data,
}: {
    uri?: string;
    data?: object | string;
}): Promise<FetchJsonResult> => {
    const body = data ? JSON.stringify(data) : null;
    const headers = {
        'Content-Type': 'application/json',
    };

    try {
        const response = await fetch(`${uri}`, {
            method: 'GET',
            headers,
            body,
            cache: 'no-store',
        });

        if (response.ok) {
            return await httpOk(response);
        } else {
            return await httpError(response);
        }
    } catch (error) {
        return fetchError(error);
    }
};



// Helper functions

const httpError = async (response: Response): Promise<FetchHttpProblem> => {
    const problem = await response.json();

    return {
        ok: false,
        error: 'http',
        status: response.status,
        statusText: response.statusText,
        problem,
    };
};

const httpOk = async (response: Response): Promise<FetchJsonResult> => {
    // Handle no content
    if (response.status === 204) {
        return {
            ok: true,
            status: response.status,
            statusText: response.statusText,
            data: { ok: true },
        };
    }

    const data = await response.json();
    const json = typeof data === 'string' ? JSON.parse(data) : data;

    return {
        ok: true,
        status: response.status,
        statusText: response.statusText,
        data: json,
    };
};

const fetchError = (error: unknown): FetchError => {
    if (error instanceof Error) {
        return {
            ok: false,
            error: 'request',
            name: error.name,
            message: error.message,
        };
    }

    return {
        ok: false,
        error: 'request',
        name: 'unknown',
        message: '',
    };
};
